import SarSymbol from '@/components/SarSymbol';
import AedSymbol from '@/components/AedSymbol';

const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  INR: '₹',
  BHD: '.د.ب',
  KWD: 'د.ك',
};

/**
 * Returns the display symbol/element for a currency code.
 * For SAR and AED, returns the official SVG symbol components.
 */
export function getCurrencySymbol(code: string, size = 14): React.ReactNode {
  if (code === 'SAR') return <SarSymbol size={size} />;
  if (code === 'AED') return <AedSymbol size={size} />;
  return CURRENCY_SYMBOLS[code] || code;
}

/**
 * Returns a label string for use in select dropdowns.
 */
export function getCurrencyLabel(code: string): string {
  if (code === 'SAR') return 'SAR';
  if (code === 'AED') return 'AED';
  const sym = CURRENCY_SYMBOLS[code];
  return sym ? `${code} (${sym})` : code;
}
